
import GiftCardBarcode from "@fixit/v-gift-card-barcode/src/GiftCardBarcode.vue";
import GiftCardSvc from "../../../../../services/gift-card-svc";
import { NoContent } from "../../../../Common/CommonComponents";
let giftCardSvc = null;
export default {
  components: {
    GiftCardBarcode,
    NoContent,
  },
  props: {
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
  },
  data() {
    return {
      myGiftCard: [],
      isLoading: false,
    };
  },
  computed: {
    giftCardApi() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_GIFT_CARD_API_URL
        : this.$config.VUE_APP_FIXIT_GIFT_CARD_API_URL
        ? this.$config.VUE_APP_FIXIT_GIFT_CARD_API_URL
        : process.env.VUE_APP_FIXIT_GIFT_CARD_API_URL;
    },
  },

  async created() {
    this.isLoading = true;
    giftCardSvc = await GiftCardSvc(this.$axios);
    this.myGiftCard = await giftCardSvc.GetGiftCardDetails(
      this.giftCardApi,
      this.layout == "chain" ? this.$route.query : this.$route.params
    );
    this.isLoading = false;
  },
};
